import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ConexionComponent } from "./conexion";

type Entity = models.CamionCajasConectadas;
export interface Props {
    value: Entity[];
}

/**Muestra un CamionCajasConectadas */
  class ConexionesComponentNoRx extends React.PureComponent<Props> {
    value = (props: Props) => props.value;

    render() {
        const { value } = this.props;

        return (
            kea.autogrid(3, value.map(x => <ConexionComponent value={x} />))
        );
    }
}

export const ConexionesComponent = componentToRx(ConexionesComponentNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscajaruta/conexiones/conexiones.tsx